import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { ModalContainerStyled, ModalStyled } from './styles/Modal';

const Modal = ({ isShowing, hide, children, closeButton, className }) => {
  if (isShowing) {
    return ReactDOM.createPortal(
      <ModalContainerStyled className={className}>
        <div className="modal-overlay" />
        <div
          className="modal-wrapper"
          aria-modal
          aria-hidden
          tabIndex={-1}
          role="dialog"
        >
          <ModalStyled>
            <div className="modal-header">
              <button
                type="button"
                className={`modal-close-button ${closeButton}`}
                data-dismiss="modal"
                onClick={hide}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <>{children}</>
          </ModalStyled>
        </div>
      </ModalContainerStyled>,
      document.body
    );
  }

  return null;
};

export default Modal;

Modal.propTypes = {
  closeButton: PropTypes.string,
  width: PropTypes.string,
  className: PropTypes.string,
};

Modal.defaultProps = {
  closeButton: 'show',
  width: '500px',
  className: '',
};
